/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Automatic_Save_FailedInputs */

const en_automatic_save_failed = /** @type {(inputs: Automatic_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic save failed. ${i?.message}`)
};

const fr_automatic_save_failed = /** @type {(inputs: Automatic_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La sauvegarde automatique a échoué. ${i?.message}`)
};

const de_automatic_save_failed = /** @type {(inputs: Automatic_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatisches Speichern fehlgeschlagen. ${i?.message}`)
};

const it_automatic_save_failed = /** @type {(inputs: Automatic_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Salvataggio automatico fallito. ${i?.message}`)
};

const ru_automatic_save_failed = /** @type {(inputs: Automatic_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Автоматическое сохранение не удалось. ${i?.message}`)
};

const es_automatic_save_failed = /** @type {(inputs: Automatic_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en el guardado automático. ${i?.message}`)
};

const zh_cn2_automatic_save_failed = /** @type {(inputs: Automatic_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自动保存失败。${i?.message}`)
};

const ja_automatic_save_failed = /** @type {(inputs: Automatic_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自動保存に失敗しました。${i?.message}`)
};

const hi_automatic_save_failed = /** @type {(inputs: Automatic_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्वचालित सेव विफल। ${i?.message}`)
};

const pt_pt2_automatic_save_failed = /** @type {(inputs: Automatic_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O salvamento automático falhou. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Automatic save failed. {message}" |
*
* @param {Automatic_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_failed = /** @type {((inputs: Automatic_Save_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_failed(inputs)
	if (locale === "de") return de_automatic_save_failed(inputs)
	if (locale === "it") return it_automatic_save_failed(inputs)
	if (locale === "ru") return ru_automatic_save_failed(inputs)
	if (locale === "es") return es_automatic_save_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_failed(inputs)
	if (locale === "ja") return ja_automatic_save_failed(inputs)
	if (locale === "hi") return hi_automatic_save_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_failed(inputs)
	return en_automatic_save_failed(inputs)
});